
let eventTypes =
  [
    // login
    'Logged in',
    // user
    'User list requested',
    'User created',
    'User requested',
    'User updated',
    'User deleted',
    // keystore
    'KeyStore list requested',
    'KeyStore created',
    'KeyStore activated',
    'KeyStore deactivated',
    'KeyStore requested',
    'KeyStore entries requested',
    'KeyStore names requested',
    'KeyStore deleted',
    // tsResponder
    'TsResponder list requested',
    'TsResponder created',
    'TsResponder requested',
    'TsResponder updated',
    'TsResponder deleted',
    // docSigner
    'DocSigner list requested',
    'DocSigner created',
    'DocSigner requested',
    'DocSigner updated',
    'DocSigner deleted',
    // audit
    'Audit logger requested',
    'Audit logger updated',
    'Audit logs signed',
    'Audit logs verified',
    'Audit logs requested',
    'Audit log list requested',
    // report
    'Timestamp report logs requested',
    'Timestamp report log list requested',
    // system
    'Current time requested',
    'Version info requested',
    'Audit Logger KeyStore activated',
    'Log file list requested',
    'Log file requested',
    'SSL PKCS12 uploaded',
    'NTP stats'
  ]

export default eventTypes
